import { type GenericListQueryKey, generateInfiniteQueryKey, generateListQueryKey } from '@pba/react-query';
import type { Pagination } from 'models';
import { generateQueryKey } from 'query/generate-query-key';
import type { UserFilter } from '../types';
import type { NodeUsersQueryFilter } from './useGetNodeUsers';

type UserParams = {
  filter: UserFilter;
};

const featureKey = 'users';

type NodeUsersParams = {
  filter?: NodeUsersQueryFilter;
  pagination?: Partial<Pagination>;
};

export const getUsersFeatureQueryKey = () => generateQueryKey([featureKey]);

export const getEducationLevelsQueryKey = () => generateQueryKey([...getUsersFeatureQueryKey(), 'education-levels']);

export const getProfessionsQueryKey = () => generateQueryKey([...getUsersFeatureQueryKey(), 'professions']);

export const getGendersQueryKey = () => generateQueryKey([...getUsersFeatureQueryKey(), 'genders']);

export const getInterestsQueryKey = () => generateQueryKey([...getUsersFeatureQueryKey(), 'interests']);

export const getProfileQueryKey = () => generateQueryKey([...getUsersFeatureQueryKey(), 'profile']);

export const getUserQueryKey = ({ filter }: UserParams) =>
  generateQueryKey([...getUsersFeatureQueryKey(), 'detail', { filter }]);

export const getProfileNodeQueryKey = () => generateQueryKey([...getUsersFeatureQueryKey(), 'profile-node']);

export const getNodeUsersQueryKey = ({ filter, pagination }: NodeUsersParams) =>
  generateQueryKey([...getUsersFeatureQueryKey(), 'node', 'users', { filter, pagination }]);

export const getBadgesQueryKey = () => generateQueryKey([...getUsersFeatureQueryKey(), 'notification-badges']);

type GetUsersQueryFilter = {
  excludeCommunityId?: string;
  excludeProgramId?: string;
  search?: string;
};

type UsersListQueryType = GenericListQueryKey<GetUsersQueryFilter>;

export const getUsersListQueryKey = (params: UsersListQueryType) =>
  generateListQueryKey({
    prefix: [featureKey],
  })(params);

export const getUsersInfiniteQueryKey = generateInfiniteQueryKey({
  generateListQueryKey: getUsersListQueryKey,
});
